<button type="button" class="wb-tone-trigger" cdkOverlayOrigin #trigger="cdkOverlayOrigin" #triggerEl (click)="toggle()" [disabled]="$disabled()">
  <span class="wb-tone-dot" [attr.data-tone]="$value()"></span>
</button>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="$isOpen()"
  [cdkConnectedOverlayHasBackdrop]="false"
  [cdkConnectedOverlayPositions]="positions"
  (overlayOutsideClick)="close()"
  (attach)="onAttached()">

  <div class="wb-tone-overlay" tabindex="0" role="grid" #overlayRoot (keydown)="onOverlayKeydown($event)">
    @for (swatch of $swatches(); track swatch.tone; let i = $index) {
      <button type="button" class="wb-tone-cell" role="gridcell" [class.selected]="swatch.tone === $value()" [class.active]="i === $activeIndex()" (mouseenter)="setActive(i)" (click)="onSelect(swatch.tone)" [attr.aria-label]="swatch.tone" tabindex="-1">
        <span class="wb-tone-cell-dot" [attr.data-tone]="swatch.tone"></span>
      </button>
    }
  </div>

</ng-template>
